import { FormSchema, SelectFormItem } from "../components/tc-form/types";

export const createRegionForm = (): FormSchema => [
  [{ type: "text", propName: "name", label: "Region Name" }],
];
